'use client';

import { FC, PropsWithChildren } from 'react';
import { TranslationMemoryProvider } from './_context/TranslationMemoryContext';

const TranslationMemoryLayout: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return <TranslationMemoryProvider>{children}</TranslationMemoryProvider>;
};

export default TranslationMemoryLayout;
